import { IconNames } from '@dixa/lib-shared-habla';

export type CopilotProductFeature = {
  readonly title: string;
  readonly description: string;
  readonly icon: IconNames;
  readonly learnMoreUrl?: string;
};

export const copilotProductFeatures: readonly CopilotProductFeature[] = [
  {
    title: 'Smart Replies',
    description: 'Boost efficiency with AI + Knowledge base.',
    icon: 'autocomplete',
    learnMoreUrl:
      'https://support.dixa.help/en/articles/1551-smart-conversation-replies',
  },
  {
    title: 'Smart Summaries',
    description: 'Get to the heart of every interaction quickly.',
    icon: 'list-ul',
    learnMoreUrl:
      'https://support.dixa.help/en/articles/1616-smart-conversation-summaries',
  },
  {
    title: 'Smart Translations',
    description: 'Break down language barriers effortlessly.',
    icon: 'translate',
    learnMoreUrl: 'https://support.dixa.help/en/articles/1702-ai-translations',
  },
  {
    title: 'AI Spellchecker',
    description: 'Perfect your writing effortlessly with advanced AI.',
    icon: 'grammar-spelling',
    learnMoreUrl: 'https://support.dixa.help/en/articles/1709-ai-spellchecker',
  },
  {
    title: 'Improve Reply',
    description: 'Communicate with precision, and on the tone.',
    icon: 'pen',
    learnMoreUrl: 'https://support.dixa.help/en/articles/1736-improve-reply',
  },
  {
    title: 'Tag suggestions',
    description: 'Get AI suggestions for tags on each conversation.',
    icon: 'tag',
    learnMoreUrl:
      'https://support.dixa.help/en/articles/2115-early-access-suggested-tags',
  },
  {
    title: 'Custom attribute suggestions',
    description:
      'Get AI suggestions for custom attributes from the conversation.',
    icon: 'input',
    learnMoreUrl:
      'https://support.dixa.help/en/articles/2144-early-access-suggested-values-for-conversation-attributes',
  },
  {
    title: 'AI drafts',
    description:
      'Generate reply drafts in the editor from conversation context and knowledge.',
    icon: 'mim',
    learnMoreUrl:
      'https://support.dixa.help/en/articles/2158-co-pilot-ai-drafts-early-access',
  },
];
